import { cx } from './ui'

export const STATUSES = ['pending', 'approved', 'in_progress', 'completed', 'rejected', 'failed'] as const
export type Status = (typeof STATUSES)[number]

export const STATUS_STYLE: Record<Status, { label: string; dot: string; text: string }> = {
  pending: { label: 'Pending', dot: 'bg-[#c4c4c4]', text: 'text-ink' },
  approved: { label: 'Approved', dot: 'bg-brand', text: 'text-brand' },
  in_progress: { label: 'In Progress', dot: 'bg-[#8abc2d]', text: 'text-[#7aa826]' },
  completed: { label: 'Completed', dot: 'bg-[#4aa785]', text: 'text-[#3d9474]' },
  rejected: { label: 'Rejected', dot: 'bg-[#7c7c7c]', text: 'text-[#7c7c7c]' },
  failed: { label: 'Failed', dot: 'bg-danger', text: 'text-danger' },
}

// What each status can move to (mirrors the API's rules), with the verb shown in the row menu.
export const ACTIONS: Record<Status, [Status, string][]> = {
  pending: [['approved', 'Approve'], ['rejected', 'Reject']],
  approved: [['in_progress', 'Mark in progress'], ['completed', 'Complete & supply'], ['rejected', 'Reject']],
  in_progress: [['completed', 'Complete & supply'], ['failed', 'Mark failed']],
  completed: [],
  rejected: [],
  failed: [['pending', 'Reopen']],
}

export function StatusPill({ status }: { status: Status }) {
  const s = STATUS_STYLE[status]
  return <span className={cx('inline-flex items-center gap-1.5 text-xs', s.text)}><span className={cx('size-1.5 rounded-full', s.dot)} />{s.label}</span>
}

